import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { RootState } from '@swf/core/store';

import { useCMSPageWidget } from '../../../../widgets/cms-page-widget/model';

const defaultSelector = (rootState: RootState) => rootState;

const useLightHeader = () => {
  const pageWidget = useSelector((rootState: RootState) =>
    select.page.getWidget(rootState, 'CMSPageWidget')
  );
  const { widgetSelect } = useCMSPageWidget(pageWidget?.id);
  const { page: { light_header: lightHeader = false } = {} } = useSelector(
    widgetSelect?.get || defaultSelector
  );

  return lightHeader;
};

export default useLightHeader;
